import React, { useState, useEffect } from 'react';
import './EditorStyles.css';
import ProjectModal from './ProjectModal';

const PortfolioEditor = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [editingProject, setEditingProject] = useState(null);

  useEffect(() => {
    loadProjects();
  }, []);

  const loadProjects = async () => {
    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/portfolio`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });
      const data = await response.json();
      if (data.success) {
        setProjects(data.data);
      }
    } catch (error) {
      console.error('Error loading projects:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleAdd = () => {
    setEditingProject(null);
    setShowModal(true);
  };

  const handleEdit = (project) => {
    setEditingProject(project);
    setShowModal(true);
  };

  const handleSave = async (formData) => {
    try {
      const token = localStorage.getItem('dashboard_token');
      const url = editingProject
        ? `${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/portfolio/${editingProject.id}`
        : `${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/portfolio`;
      
      const method = editingProject ? 'PUT' : 'POST';

      const response = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();
      if (data.success) {
        setMessage(editingProject ? 'تم تحديث المشروع بنجاح!' : 'تم إضافة المشروع بنجاح!');
        setShowModal(false);
        setEditingProject(null);
        loadProjects();
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage(data.message || 'حدث خطأ');
      }
    } catch (error) {
      console.error('Save error:', error);
      setMessage('خطأ في الاتصال');
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('هل أنت متأكد من حذف هذا المشروع؟')) return;

    try {
      const token = localStorage.getItem('dashboard_token');
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://server.acpca.net/api'}/portfolio/${id}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${token}`
        }
      });

      const data = await response.json();
      if (data.success) {
        setMessage('تم حذف المشروع بنجاح!');
        loadProjects();
        setTimeout(() => setMessage(''), 3000);
      } else {
        setMessage(data.message || 'حدث خطأ');
      }
    } catch (error) {
      console.error('Delete error:', error);
      setMessage('خطأ في الاتصال');
    }
  };

  if (loading) {
    return <div className="editor-loading">جاري التحميل...</div>;
  }

  return (
    <div className="editor-container">
      <div className="editor-header">
        <h2>إدارة المشاريع</h2>
        {message && (
          <div className={`editor-message ${message.includes('نجح') || message.includes('success') ? 'success' : 'error'}`}>
            {message}
          </div>
        )}
        <button className="editor-btn-add" onClick={handleAdd}>
          + إضافة مشروع جديد
        </button>
      </div>

      <div className="editor-items-list">
        {projects.length === 0 ? (
          <p style={{ textAlign: 'center', padding: '40px', color: '#666' }}>لا توجد مشاريع</p>
        ) : (
          projects.map((project) => (
            <div key={project.id} className="editor-item-card">
              <div className="editor-item-content">
                <h4>{project.title_ar || project.title_en || `مشروع ${project.id}`}</h4>
                <p>العلامة: {project.tag_ar || project.tag_en || 'غير محدد'}</p>
                {project.image_url && (
                  <img 
                    src={project.image_url && (project.image_url.startsWith('http') ? project.image_url : `${process.env.REACT_APP_API_URL ? process.env.REACT_APP_API_URL.replace('/api', '') : 'https://server.acpca.net'}${project.image_url.startsWith('/') ? project.image_url : `/${project.image_url}`}`)} 
                    alt="Project" 
                    style={{maxWidth: '150px', marginTop: '10px', borderRadius: '4px'}}
                  />
                )}
              </div>
              <div className="editor-item-actions">
                <button className="editor-btn-sm editor-btn-edit" onClick={() => handleEdit(project)}>
                  تعديل
                </button>
                <button className="editor-btn-sm editor-btn-delete" onClick={() => handleDelete(project.id)}>
                  حذف
                </button>
              </div>
            </div>
          ))
        )}
      </div>

      {showModal && (
        <ProjectModal
          project={editingProject}
          onClose={() => {
            setShowModal(false);
            setEditingProject(null);
          }}
          onSave={handleSave}
        />
      )}
    </div>
  );
};

export default PortfolioEditor;

